import { ArrowRightCircle, ChevronsRight } from "react-feather";
import { H6, P } from "../../../../../AbstractElements";
import { FULLSCREEN_MODAL_LIST } from "../../../../../Data/UiKit/Modal";
import { WebDesigner, WebDesigns } from "../../../../../Constant";

const WebDesign = () => {
  return (
    <>
      <div className="large-modal-header mb-1">
        <ChevronsRight />
        <H6>{WebDesigns}</H6>
      </div>
      <P className="modal-padding-space">We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.</P>
      <H6>{WebDesigner}</H6>
      <div className="d-flex mt-3">
        <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal"/></div>
        <div className="flex-grow-1 ms-2">
          <P className="mb-0">For a site to be successful, a designer must be able to communicate their ideas, chat with a firm about what they want, and inquire about the target audience.</P>
        </div>
      </div>
      {FULLSCREEN_MODAL_LIST.map((item, index) => (
        <div className="d-flex mt-1" key={index}>
          <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal"/></div>
          <div className="flex-grow-1 ms-2"><P className="mb-0">{item}</P></div>
        </div>
      ))}
    </>
  );
};

export default WebDesign;
